// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/icons/search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar {
    height: 67px;
    padding: 10px 30px;
    font-size: 40px;
    border-radius: 8px;
    border: 1px solid #808080;
    width: 50vw;
    min-width: 300px;
}

.searchBar.small {
    height: 47px;
    padding: 20px;
    font-size: 28px;
    border-radius: 6px;
    border: 1px solid #808080;
    width: 50vw;
    min-width: 300px;
}

.searchButton {
    height: 67px;
    width: 67px;
    border: none;
    border-radius: 0 8px 8px 0;
    background-color: #1faeff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: 50px 50px;
    background-repeat: no-repeat;
    color: white;
    right: 0;
    position: absolute;
    cursor: pointer;
}

.searchButton.small {
    height: 47px;
    width: 47px;
    background-size: 32px;
}

.searchBarContainer {
    position: relative;
}

.searchBarContainer ul {
    display: none;
    position: absolute;
    background: #fff;
    top: 100%;
    margin: 0;
    border: 3px solid #1faeff;
    border-top: none;
    border-radius: 0 0 10px 10px;
    list-style: none;
    padding: 0;
    max-height: 165px;
    overflow-y: scroll;
}

.searchBar:focus+ul,
.searchBarContainer ul:hover {
    display: block;
}

.searchBarContainer li {
    padding: 5px 10px;
    cursor: pointer;
}

.searchBarContainer li:hover {
    background: #1faeff;
    color: #fff;
    font-weight: bold;
    ;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Components/css/Search.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,yDAAuD;IACvD,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;;AAErB","sourcesContent":[".searchBar {\n    height: 67px;\n    padding: 10px 30px;\n    font-size: 40px;\n    border-radius: 8px;\n    border: 1px solid #808080;\n    width: 50vw;\n    min-width: 300px;\n}\n\n.searchBar.small {\n    height: 47px;\n    padding: 20px;\n    font-size: 28px;\n    border-radius: 6px;\n    border: 1px solid #808080;\n    width: 50vw;\n    min-width: 300px;\n}\n\n.searchButton {\n    height: 67px;\n    width: 67px;\n    border: none;\n    border-radius: 0 8px 8px 0;\n    background-color: #1faeff;\n    background-image: url(../../../assets/icons/search.svg);\n    background-position: center;\n    background-size: 50px 50px;\n    background-repeat: no-repeat;\n    color: white;\n    right: 0;\n    position: absolute;\n    cursor: pointer;\n}\n\n.searchButton.small {\n    height: 47px;\n    width: 47px;\n    background-size: 32px;\n}\n\n.searchBarContainer {\n    position: relative;\n}\n\n.searchBarContainer ul {\n    display: none;\n    position: absolute;\n    background: #fff;\n    top: 100%;\n    margin: 0;\n    border: 3px solid #1faeff;\n    border-top: none;\n    border-radius: 0 0 10px 10px;\n    list-style: none;\n    padding: 0;\n    max-height: 165px;\n    overflow-y: scroll;\n}\n\n.searchBar:focus+ul,\n.searchBarContainer ul:hover {\n    display: block;\n}\n\n.searchBarContainer li {\n    padding: 5px 10px;\n    cursor: pointer;\n}\n\n.searchBarContainer li:hover {\n    background: #1faeff;\n    color: #fff;\n    font-weight: bold;\n    ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
